import { render, staticRenderFns } from "./Assessment.vue?vue&type=template&id=17518587&scoped=true&"
import script from "./Assessment.vue?vue&type=script&lang=js&"
export * from "./Assessment.vue?vue&type=script&lang=js&"
import style0 from "./Assessment.vue?vue&type=style&index=0&id=17518587&prod&lang=scss&scoped=true&"
import style1 from "./Assessment.vue?vue&type=style&index=1&id=17518587&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17518587",
  null
  
)

export default component.exports